import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/criteria', component: List, name: 'criteria.index'},
  {path: '/criteria/store', component: Form, name: 'criteria.store'},
  {path: '/criteria/:id', component: Form, name: 'criteria.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/criteria/routes.js